
































































































































































import {
    computed,
    defineComponent,
    onMounted,
    onUnmounted,
    ref,
} from '@vue/composition-api';
import {
    SdsDividerLine,
    SdsButtonText,
} from '@superbet-group/web.lib.ui-components';
import {
    useI18n,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import { AccountFlagNames } from '@app/modules/userProfile/account/FeatureFlags';
import { AuthenticationStore } from '@store/modules/data/authentication/authenticationIndex';
import SdsPageHeader from '@shared/components/pageHeader/SdsPageHeader.vue';
import { RouteName } from '@src/app/router/constants/RouteName';
import { getFederationComponent } from '@src/federations/getFederationComponent';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import modalIndex from '@store/modules/ui/shared/modal/modalIndex';
import { isBelgium } from '@modules/layout/utils/isCountry';
import { isSocialEnabled } from '@socialFederation/helpers';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import Survey from '@modules/survey/Survey.vue';
import { getShellConfig } from '@src/config/shell/config';
import { Unsubscribe } from '@superbet-group/web.lib.feature-toggle-service';
import BankAccountsManagement from '../../../../federations/wallet/src/components/BankAccountsManagement.vue';

export default defineComponent({
    name: 'SdsProfileContainer',
    setup() {
        const isProfileEditEnabled = ref(false);
        const isBankAccountsManagementEnabled = ref(false);
        let featureBankAccountsManagementSubscriptionUnsubscribeFn: Unsubscribe;
        const authModule = useVuexStore<AuthenticationStore>('data/authentication');
        const user = authModule.getter('user');

        const { formatDateTime } = useI18n();
        const surveyPageSetup = getShellConfig().remoteConfig.profilePageSurveySetup;
        onMounted(async () => {
            featureBankAccountsManagementSubscriptionUnsubscribeFn = featureFlagService.subscribeToFeatureChanges('wallet.bankAccountsManagement.isEnabled', (value) => {
                isBankAccountsManagementEnabled.value = value;
            }, false);

            isProfileEditEnabled.value = await featureFlagService.getFeatureValue(
                AccountFlagNames.isProfileEdit,
                false,
            );
        });

        onUnmounted(() => {
            featureBankAccountsManagementSubscriptionUnsubscribeFn?.();
        });

        const modalModule = useVuexStore<typeof modalIndex>('ui/modal');
        const setModal = modalModule.action('setModal');
        const closeModal = modalModule.action('closeModal');

        function updateUsername() {
            closeModal();
            setModal({
                code: modalCodes.usernameUpdate,
                isClosable: true,
            });
        }

        const getFullAddress = (street?: string, city?: string, postalCode?: string | null): string => {
            return [street, city, postalCode]
                .filter((address) => address && address.trim() !== '')
                .join(', ');
        };

        const dateOfBirth = computed(() => {
            const [year, month, day] = user.value?.dateOfBirth?.split('-').map((str) => parseInt(str)) ?? [];
            return user.value?.dateOfBirth ? formatDateTime(new Date(year, month - 1, day), 'ddmmyyyy') : '';
        });

        const registrationDate = computed(() =>
            user.value?.registrationDate ? formatDateTime(new Date(user.value?.registrationDate), 'ddmmyyHHMM') : '',
        );

        return {
            RouteName,
            isProfileEditEnabled,
            isBelgium,
            dateOfBirth,
            registrationDate,
            userId: computed(() => user.value?.userId),
            phone: computed(() => user.value?.phone),
            email: computed(() => user.value?.email ?? ''),
            fullName: computed(() => user.value?.fullName),
            username: computed(() => user.value?.username),
            fullAddress: computed(() => getFullAddress(user.value?.address, user.value?.city, user.value?.postalCode)),
            updateUsername,
            isSocialEnabled: isSocialEnabled(),
            isUsernameDisplayed: shellLocalConfig.isUsernameDisplayed,
            surveyPageSetup,
            isBankAccountsManagementEnabled,
        };
    },
    components: {
        SdsPageHeader,
        SdsButtonText,
        SdsDividerLine,
        SocialProfileImageEdit: getFederationComponent(() => import('social/ProfileImageEdit')),
        SocialEditSocialBanner: getFederationComponent(() => import('social/EditSocialBanner')),
        Survey,
        BankAccountsManagement,
    },
});
